export const SUPPORT_CONTACT = {
  title: 'Contact Us',
  subtitle: 'Stay in touch with us',
  description:
    'Have questions or need help with airtime, data, bills, wallet funding, or verification? Reach out through any channel below.',
  email: 'info@asdatalink.com',
  phoneDisplay: '+234 806 666 6663',
  phoneTel: '+2348066666663',
  whatsappNumber: '2348066664224',
  whatsappDisplay: 'Chat on WhatsApp',
  location: 'Katsina, Nigeria',
  hours: '24/7 customer support',
} as const;

export function getWhatsAppSupportUrl(message?: string) {
  const base = `https://wa.me/${SUPPORT_CONTACT.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export const SUPPORT_FAQ = [
  {
    question: 'How do I contact you?',
    answer: 'Use this Contact Support page for phone, email, and WhatsApp. We respond as quickly as we can.',
  },
  {
    question: 'I just bought data but have not received it',
    answer:
      'There may be a delay from the network. Send 2 to 323 or dial *323# to confirm your balance. Check that the phone number is correct. If you still have not received the data after 12 hours, contact us with your transaction reference.',
  },
  {
    question: 'I made a bank transfer but it is not reflected yet',
    answer:
      'This can happen due to a delay from your bank or a general banking issue. Please wait — once the transfer is received, your wallet will be credited automatically.',
  },
  {
    question: 'How do I check my data balance?',
    answer: 'Send 2 to 323 or dial *323# on your line.',
  },
] as const;

export const SUPPORT_CHANNELS = [
  {
    id: 'phone',
    label: 'Phone',
    value: SUPPORT_CONTACT.phoneDisplay,
    href: `tel:${SUPPORT_CONTACT.phoneTel}`,
    external: false,
  },
  {
    id: 'email',
    label: 'Email',
    value: SUPPORT_CONTACT.email,
    href: `mailto:${SUPPORT_CONTACT.email}`,
    external: false,
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    value: SUPPORT_CONTACT.whatsappDisplay,
    href: getWhatsAppSupportUrl('Hello AS DataLink support, I need help with my account.'),
    external: true,
  },
  {
    id: 'location',
    label: 'Location',
    value: SUPPORT_CONTACT.location,
    href: undefined,
    external: false,
  },
] as const;
